import * as React from 'react';
import { getBrowserDetails } from 'utils/userAgentUtils';
import get from 'lodash/get';
import cx from 'classnames';
import StringWidget from 'components/StringWidget/StringWidget';
import imgLock from 'images/webpush/lock.png';
import styles from './HowToUnblock.css';
export default function HowToUnblock(props) {
    const className = get(props, 'className', '');
    const browserDetils = getBrowserDetails();
    const browserName = get(browserDetils, 'name');
    // Instructions for how to unblock will vary based on browsers.
    // Below method returns steps depends on browser. Default we return chrome steps.
    const browserInfo = () => {
        switch (browserName) {
            case 'Edge':
                return <span>&gt; Notifications &gt; On</span>;
            case 'Firefox':
                return <span>&gt; Permissions &gt; Notifications &gt; Allow</span>;
            default:
                return <span>&gt; Notifications &gt; Allow</span>;
        }
    };
    return (<div className={cx(styles['ht-unblock'], className)}>
			<StringWidget strKey="webAPINotificationReactivateLockMsg" className={styles['lock-msg']}/>
			<div className={styles['manual']}>
				<img className={styles['img']} src={imgLock}/>
				{browserInfo()}
			</div>
		</div>);
}
